let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jvcwg")).then(() => parcelRequire('eBpal'));